<div class="showModal package-link-display-modal" *ngIf="!isBookAppointment && state !== 'INVALID'">
<div class="package-link-wrapper">
        <div class="header border-bottom">
            <div class="font-primary-subtitle bold">{{ 'DOCCONSULT#HEADER#LABEL#DOCCONSULT' | translate }}</div>
            <div class="float-right closeicon pointer" (click)="closeModal()">
                <img src="./assets/icons/close_black.svg">
            </div>
        </div>
        <div class="content border-bottom">
            <div class="chat cursor-pointer lang-icon type-image" id="language-actions" (click)="switchLanguageAction()">
                <label class="locale-name" (click)="onItemChange(isNotSelected); $event.stopPropagation()">
                  {{isNotSelected['localName']}}
                </label>
                <img src="assets/icons/header/world.svg"  class="type-image" />
              </div>
            <div class="actions" id="language-action-options" *ngIf="switchLanguage">
                <ul class="list-group">
                  <li class="list-group-item cursor-pointer"  *ngFor="let item of languageList">
                    <input type="radio" name="label" [checked]="isSelected === item.localeCode ? true: false"
                      (change)="onItemChange(item)" [id]="'lang'+item.localeCode">
                    <label class="label" [for]="'lang'+item.localeCode">{{item.localName}} </label>
                  </li>
                </ul>
              </div>
              <div class="patient-name" *ngIf="packageInfo?.patientName">
                {{'DOCCONSULT#CONTENT#TEXT#PATIENTNAME' | translate}} {{packageInfo?.patientName}}
              </div>
            <div class="logo-section">
                <img src="assets/images/signin/nahdi_logo.png" class="type-image" alt="clinic-logo">
            </div>
            <div class="logo-section package-title">
                {{packageDefinition['name'] | translate:'LOCALE':'name'}}
            </div>
            <div class="test-list-container">
                <ng-container  *ngFor="let service of packageUtilisation?.packageServDtls; let last = last">
                <div class="test-item" *ngIf="!serviceInfo ||(serviceInfo &&service['orderId'] !== serviceInfo['orderId'])"
                     [ngClass]="{'border-bottom': !last}">
                    <div class="test-item-align">
                        <div class="test-title">{{ service.serviceDesc }}</div>
                        <div class="test-date">{{ service.startDate | moment: 'DD MMM YYYY' }}</div>
                    </div>
                    <div class="download-icon pointer" *ngIf="service.reportId" (click)="downloadReport(service.reportId)">
                        <img src="assets/icons/download.svg"  class="type-image" />
                    </div>
                </div>
            </ng-container>
            </div>
            <div class="app-info-box">
                <div class="web-text">{{ 'DOCCONSULT#CONTENT#TEXT#APPINFOWEB' | translate }}</div>
                <div class="mobile-text">{{ 'DOCCONSULT#CONTENT#TEXT#APPINFOMOBILE' | translate }}</div>
                <div class="app-buttons">
                    <img src="assets/icons/Home/apple_play.png" class="app-img pointer type-image" alt="app-store" (click)="download('apple')">
                    <img src="assets/icons/Home/google-play-badge.svg" class="google-img pointer type-image" alt="google-play" (click)="download('android')">
                </div>
            </div>
        </div>
        <div class="footer" *ngIf="serviceInfo">
            <div class="footer-content" *ngIf="enableOnspotConsult && !enableJoinAgain">
                <div class="footer-info col-md-6 col-12">
                    <img src="assets/icons/infoicon.svg" />
                    <div>{{ 'DOCCONSULT#FOOTER#TEXT#PACKAGESLOTINFO' | translate:'CONSULT_TIME':null:null:{'ltr': timeFrom, 'rtr': timeTo } }}</div>
                </div>
                <div class="footer-btn col-md-6 col-12">
                    <button class="primary-button pointer" (click)="openOnspotConsult()">{{ 'DOCCONSULT#FOOTER#BUTTON#DOCCONSULT' | translate }}</button>
                </div>
            </div>
            <button class="primary-button pointer" *ngIf="enableJoinAgain" (click)="joinAgain()">{{ 'DOCCONSULT#FOOTER#BUTTON#JOINAGAIN' | translate }}</button>
            <div class="footer-content" *ngIf="isConsultationComplete">
                <div class="footer-info col-md-6 col-12">
                    <img src="assets/icons/infoicon.svg" />
                    <div>{{ 'DOCCONSULT#FOOTER#TEXT#CONSULTCOMPLETE' | translate }}</div>
                </div>
            </div>
            <div class="footer-content" *ngIf="!enableOnspotConsult && !enableJoinAgain && !isConsultationComplete">
                <div class="footer-info col-md-6 col-12">
                    <img src="assets/icons/infoicon.svg" />
                    <div>{{ 'DOCCONSULT#FOOTER#TEXT#CONSULTINFO' | translate }}</div>
                </div>
                <!-- <div class="footer-btn col-md-6 col-12">
                    <button class="primary-button pointer consultation-btn" (click)="takeToHome()">{{ 'DOCCONSULT#FOOTER#BUTTON#NEWCONSULT' | translate }}</button>
                </div> -->
            </div>
        </div>
</div>
</div>
<div class="showModal package-link-display-modal" *ngIf="state === 'INVALID'">
    <div class="package-link-wrapper">
        <div class="header border-bottom">
            <div class="font-primary-subtitle bold">{{ 'DOCCONSULT#HEADER#LABEL#DOCCONSULT' | translate }}</div>
            <div class="float-right closeicon pointer" (click)="closeModal()">
                <img src="./assets/icons/close_black.svg">
            </div>
        </div>
        <div class="content border-bottom">
            <div class="chat cursor-pointer lang-icon type-image" id="language-actions" (click)="switchLanguageAction()">
                <label class="locale-name" (click)="onItemChange(isNotSelected); $event.stopPropagation()">
                  {{isNotSelected['localName']}}
                </label>
                <img src="assets/icons/header/world.svg"/>
              </div>
            <div class="actions" id="language-action-options" *ngIf="switchLanguage">
                <ul class="list-group">
                  <li class="list-group-item cursor-pointer"  *ngFor="let item of languageList">
                    <input type="radio" name="label" [checked]="isSelected === item.localeCode ? true: false"
                      (change)="onItemChange(item)" [id]="'lang'+item.localeCode">
                    <label class="label" [for]="'lang'+item.localeCode">{{item.localName}} </label>
                  </li>
                </ul>
              </div>
              
            <div class="logo-section">
                <img src="assets/images/signin/nahdi_logo.png" class="type-image" alt="clinic-logo">
            </div>
            <div class="invalid-message">
                <h6 class="invalid-title bold">{{ 'DOCCONSULT#CONTENT#TEXT#INVALIDTITLE' | translate }}</h6>
                <p class="invalid-desc">{{ 'DOCCONSULT#CONTENT#TEXT#INVALIDTEXT' | translate }}</p>
            </div>
            <div class="app-info-box">
                <div class="web-text">{{ 'DOCCONSULT#CONTENT#TEXT#APPINFOWEB' | translate }}</div>
                <div class="mobile-text">{{ 'DOCCONSULT#CONTENT#TEXT#APPINFOMOBILE' | translate }}</div>
                <div class="app-buttons">
                    <img src="assets/icons/Home/apple_play.png" class="app-img pointer type-image" alt="app-store" (click)="download('apple')">
                    <img src="assets/icons/Home/google-play-badge.svg" class="google-img pointer type-image" alt="google-play" (click)="download('android')">
                </div>
            </div>
        </div>
        <div class="footer">
            <button class="primary-button pointer" (click)="takeToHome()">{{ 'DOCCONSULT#FOOTER#BUTTON#GOHOME' | translate }}</button>
        </div>
    </div>
</div>
<app-book-appointment *ngIf="isBookAppointment" (close)="closeBookAppointment($event)"
  (complete)="closeBookAppointment($event)"
  [prefillData]="prefillData">
</app-book-appointment>